import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { notification as notificationAntd } from "antd";
import "./style.css";
import VaporButton from "../button";
import uuidv4 from "uuid/v4";

const VaporNotification = props => {
  const {
    className,
    confirm,
    description,
    duration,
    onClickUrl,
    onClose,
    onConfirm,
    overlay,
    position,
    size,
    title,
    textUrl,
    type
  } = props;

  const onCloseAction = onClose;

  let iconName = "info-circle";
  let iconType = "info";

  switch (type) {
  case "warning":
    iconName = "exclamation-triangle";
    iconType = "warning";
    break;
  case "success":
    iconName = "check-circle";
    iconType = "success";
    break;
  case "error":
    iconName = "minus-circle";
    iconType = "error";
    break;
  default:
    break;
  }

  let divToApp = document.createElement("p");
  divToApp.setAttribute("class", "ts-vapor-overlay");
  divToApp.setAttribute("id", "ts-vapor-overlay");

  let container = document.getElementById("root");

  if (overlay) {
    container.appendChild(divToApp);
  }

  const notificationKey = uuidv4();

  return notificationAntd.open({
    closeIcon: (
      <FontAwesomeIcon
        className={"dbx-main-notification-close-icon"}
        icon={["far", "times"]}
      />
    ),
    icon: (
      <FontAwesomeIcon
        className={"dbx-main-notification-icon " + iconType}
        icon={["fas", iconName]}
      />
    ),
    key: notificationKey,
    onClose: () => {
      if (overlay) {
        document.getElementById("ts-vapor-overlay").remove();
      }
      if (onCloseAction) {
        onCloseAction();
      }
    },
    description: (
      <React.Fragment>
        <div className="dbx-main-notification-content">
          <div>
            <span className="dbx-main-notification-title">
              {title}
              {title.indexOf(":") === -1 ? ":" : ""}
            </span>
            <span className="dbx-main-notification-description">
              {description}
            </span>
            <span className="dbx-main-notification-url" onClick={onClickUrl}>
              {textUrl}
            </span>
          </div>
          <div>
            {confirm && (
              <span className="dbx-main-notification-buttons">
                <VaporButton
                  style={{ width: "120px" }}
                  kind="secondary"
                  onClick={() => {
                    if (overlay) {
                      document.getElementById("ts-vapor-overlay").remove();
                    }
                    if (onCloseAction) {
                      onCloseAction();
                    }
                    notificationAntd.close(notificationKey);
                  }}
                >
                  Annulla
                </VaporButton>
                <VaporButton
                  style={{ width: "120px" }}
                  onClick={() => {
                    if (onConfirm) {
                      onConfirm();
                    }
                    if (overlay) {
                      document.getElementById("ts-vapor-overlay").remove();
                    }
                    if (onCloseAction) {
                      onCloseAction();
                    }
                    notificationAntd.close(notificationKey);
                  }}
                >
                  Conferma
                </VaporButton>
              </span>
            )}
          </div>
        </div>
      </React.Fragment>
    ),
    placement: position || "topRight",
    duration: duration,
    className:
      "dbx-main-notification " +
      (className || "") +
      " " +
      iconType +
      " " +
      (typeof size === "string" ? size : "")
  });
};

VaporNotification.defaultValue = {
  duration: 4.5
};

export default VaporNotification;
